import { render, staticRenderFns } from "./My360Textarea.vue?vue&type=template&id=55b10964&lang=html&"
import script from "./My360Textarea.vue?vue&type=script&lang=js&"
export * from "./My360Textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports